<template>
  <div class="bar-graph">
    <div class="graph-drawing">
      <div class="bars positive">
        <div class="bar-box" v-for="barValue of barValuesUI" :key="barValue.name" :class="barValue.cssClasses">
          <template v-if="barValue.height >= 0">
            <div class="value"><span v-if="withSign">+</span>{{ barValue.value }}</div>
            <div class="bar" :style="{ height: barValue.height + 'px' }"></div>
          </template>
        </div>
      </div>
      <div class="line"></div>
      <div class="bars negative">
        <div class="bar-box" v-for="barValue of barValuesUI" :key="barValue.name" :class="barValue.cssClasses">
          <template v-if="barValue.height < 0">
            <div class="bar" :style="{ height: -barValue.height + 'px' }"></div>
            <div class="value"><span v-if="withSign">-</span>{{ barValue.value }}</div>
          </template>
        </div>
      </div>
    </div>
    <div class="month-names">
      <div class="month-name" v-for="barValue of barValuesUI" :key="barValue.name" :class="barValue.cssClasses">
        {{ barValue.name }}
      </div>
    </div>
  </div>
</template>

<script>
import moneyUtils from '@/utils/money';
import _ from 'lodash';
import dateUtils from '@/utils/dates';

export default {
  name: 'BarGraph',
  props: {
    barValues: {
      type: Array,
      required: true,
    },
    graphHeight: {
      type: Number,
      required: true,
    },
    withSign: {
      type: Boolean,
      default: () => true,
    },
  },
  computed: {
    barValuesUI() {
      const maxValue = Math.abs(_.max([0, _.maxBy(this.barValues, ({ value }) => value).value]));
      const minValue = Math.abs(_.min([0, _.minBy(this.barValues, ({ value }) => value).value]));
      const maxBarHeight = minValue + maxValue;

      return _.map(this.barValues, barValue => {
        const barHeight = (barValue.value / maxBarHeight) * this.graphHeight;
        return {
          name: barValue.name,
          value: moneyUtils.formatAmountWithFraction(barValue.value, 0),
          cssClasses: barValue.cssClasses,
          height: barHeight,
        };
      });
    },
  },
  methods: {
    formatMonthName(budgetDate) {
      return dateUtils.getShortHebrewMonth(budgetDate);
    },
  },
};

</script>

<style lang="scss">
@import '~base-ui/src/scss/riseup-colors';

.bar-graph {
  margin: 34px 0 10px;

  .graph-drawing {
    padding-bottom: 10px;
    .line {
      height: 1px;
      background-color: $riseup_gray_0;
    }

    .bars {
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      flex-direction: row-reverse;
      font-size: 12px;
      color: $riseup_black;

      .bar-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 40px;

        .bar {
          border-radius: 10px 10px 0 0;
          background-color: $riseup_blue;
          width: 18px;
        }

        .value {
          direction: ltr;
        }
      }

      &.positive {
        .bar-box {
          .value {
            margin-bottom: 8px;
          }
        }
      }

      &.negative {
        align-items: flex-start;
        .bar-box {
          .bar {
            border-radius: 0 0 10px 10px;
          }

          .value {
            margin-top: 8px;
          }
        }
      }

      &.positive {
      }
    }
  }

  .month-names {
    display: flex;
    justify-content: space-around;
    flex-direction: row-reverse;
    text-align: center;

    .month-name {
      width: 40px;
      font-size: 16px;
      color: $riseup_gray_3;
      &.bold {
        font-weight: bold;
        color: $riseup_black
      }
      &.empty {
        font-size: 10px;
        color: $riseup_gray_1;
      }
    }
  }
}

</style>
